import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Shell from "../components/Shell";

export default function PaymentCancel() {
  return (
    <Shell>
      <div className="max-w-md mx-auto text-center py-20" data-testid="payment-cancel">
        <XCircle size={40} className="text-muted-foreground mx-auto mb-5" />
        <h1 className="font-serif text-4xl mb-2">Checkout cancelled</h1>
        <p className="text-muted-foreground mb-8">No charge was made. You can upgrade any time.</p>
        <Link to="/pricing" className="inline-block py-3 px-8 rounded-full bg-primary text-[#0B0B12] font-medium text-sm">
          Back to membership
        </Link>
      </div>
    </Shell>
  );
}
